import { render } from "./ProjectGeneralInfo.vue?vue&type=template&id=6452055f&scoped=true"
import script from "./ProjectGeneralInfo.vue?vue&type=script&lang=js"
export * from "./ProjectGeneralInfo.vue?vue&type=script&lang=js"

import "./ProjectGeneralInfo.vue?vue&type=style&index=0&id=6452055f&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6452055f"]])

export default __exports__